import {
    GET_SETTINGS_CONFIG_LOADING, GET_SETTINGS_CONFIG_SUCCESS, GET_SETTINGS_CONFIG_FAILED,
    GET_SETTINGS_CONFIG_SUCCESS_PAGINATE, GET_FILTERED_SETTINGS_CONFIG_LOADING, GET_FILTERED_SETTINGS_CONFIG_SUCCESS,
    DELETE_SETTINGS_CONFIG_SUCCESS, PAUSE_SETTINGS_CONFIG_SUCCESS, RESUME_SETTINGS_CONFIG_SUCCESS, CLEAR_SETTINGS_CONFIG,
    CLEAR_SETTINGS_CONFI_STATUS
} from '../actions/verifyConfiguration.action';
import { SettingsInterface } from '../models/settings.interface';
import remove from 'lodash/remove';
import findIndex from 'lodash/findIndex';
import { SAVE_SETTINGS_LOADING, SAVE_SETTINGS_SUCCESS, SAVE_SETTINGS_FAILED, EDIT_SETTINGS_SUCCESS } from '../actions/verify.action';

const initialState: SettingsInterface = {
    loading: true,
    error: false,
    message: "",
    data: [],
    total: 0,
    totalSettings: 0,
    filteredLoading: false
}

const SettingsReducer = (state: SettingsInterface = initialState, action: any): SettingsInterface => {
    const { data } = state;
    let index;
    let item;
    switch (action.type) {
        case GET_SETTINGS_CONFIG_LOADING:
            return {
                ...state,
                loading: true,
                error: false,
                message: ""
            }
        case GET_SETTINGS_CONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                data: action.payload.respose.data,
                total: action.payload.respose.total,
                totalSettings: action.payload.respose.total
            }
        case GET_SETTINGS_CONFIG_FAILED:
            return {
                ...state,
                loading: false,
                filteredLoading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        case GET_SETTINGS_CONFIG_SUCCESS_PAGINATE:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                filteredLoading: false,
                data: [...state.data, ...action.payload.respose.data]
            }
        case GET_FILTERED_SETTINGS_CONFIG_LOADING:
            return {
                ...state,
                loading: false,
                error: false,
                filteredLoading: true,
                data: [],
                total: 0
            }
        case GET_FILTERED_SETTINGS_CONFIG_SUCCESS:
            return {
                ...state,
                filteredLoading: false,
                data: action.payload.respose.data,
                total: action.payload.respose.total
            }
        case DELETE_SETTINGS_CONFIG_SUCCESS:
            remove(data, { id: action.payload.id });
            return {
                ...state,
                data: data,
                total: state.total - 1,
                totalSettings: state.total - 1
            }
        case PAUSE_SETTINGS_CONFIG_SUCCESS:
            index = findIndex(data, { id: action.payload.id });
            item = data[index];
            item.status = 5;
            data.splice(index, 1, item);
            return {
                ...state,
                data: data
            }
        case RESUME_SETTINGS_CONFIG_SUCCESS:
            index = findIndex(data, { id: action.payload.id });
            item = data[index];
            item.status = 1;
            data.splice(index, 1, item);
            return {
                ...state,
                data: data
            }
        case CLEAR_SETTINGS_CONFI_STATUS:
            return {
                ...state,
                error: false,
                message: ""
            }
        case CLEAR_SETTINGS_CONFIG:
            return initialState;
        case SAVE_SETTINGS_LOADING:
            return {
                ...state,
                loading: true
            }
        case SAVE_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: [action.payload.res, ...state.data],
                total: state.total + 1,
                totalSettings: state.totalSettings + 1
            }
        case EDIT_SETTINGS_SUCCESS:
            remove(data, { id: action.payload.res.id});
            return {
                ...state,
                loading: false,
                data: [action.payload.res, ...state.data]
            }
        case SAVE_SETTINGS_FAILED:
            return {
                ...state,
                error: true,
                loading: false,
                message: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export default SettingsReducer;